import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * useVisitMetrics
 * Envía una métrica de visita (page view) a Supabase cada vez que cambia la ruta.
 */
export function useVisitMetrics() {
  const location = useLocation();

  useEffect(() => {
    // Generar o recuperar un ID de sesión único por visitante
    const SESSION_KEY = 'visit_session_id';
    let sessionId = localStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      // Usa crypto.randomUUID si está disponible, si no, un fallback simple
      sessionId = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
      localStorage.setItem(SESSION_KEY, sessionId);
    }

    const trackVisit = async () => {
      try {
        // Temporalmente deshabilitado para evitar errores de CORS
        // await supabase.functions.invoke('track-visit', {
        //   body: {
        //     path: location.pathname + location.search,
        //     referrer: document.referrer || null,
        //     session_id: sessionId
        //   }
        // });
        console.log('Visita registrada (deshabilitada):', location.pathname);
      } catch (error) {
        console.warn('No se pudo registrar la visita:', error);
      }
    };

    trackVisit();
  }, [location]);
} 